module.exports = __webpack_public_path__ + "img/0Q3B1666_L_BlackMatted.19a666e4.jpg";